import { useToast as useBaseToast, UseToastOptions } from '@chakra-ui/react';
import { useCallback } from 'react';

import { Toast } from '../components/toast';
import { ToastStatus } from '../types';

const useToast = () => {
	const toast = useBaseToast();

	return useCallback(
		(options: UseToastOptions) => {
			toast({
				position: 'top-right',
				render: ({ status, title, description, ...rest }) => (
					<Toast isCloseable message={title as string} description={description as string | undefined} status={status as ToastStatus} {...rest} />
				),
				...options,
			});
		},
		[toast]
	);
};

export { useToast };
